/* eslint-disable react/prop-types */
import React from 'react';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
} from 'recharts';

const shortDate = (d) => String(d).split('-').slice(1).reverse().join('/'); // DD/MM

// Single-series sleep-sessions-per-day trend (mirrors StandingCheckTrendChart).
// Σ sessions reconciles 1:1 with the Total Sessions card. Graceful single-day/empty.
const SleepSummaryTrendChart = ({ data = [] }) => {
  const enough = data.length >= 2;
  const single = data.length === 1;

  return (
    <div className="au-panel" data-testid="ss-trend">
      <div className="au-panel__head">
        <h4 className="au-panel__title">Sleep sessions per day</h4>
        <span className="au-spacer" />
        <div className="au-legend">
          <span><i style={{ background: '#f26b45' }} />Sleep sessions</span>
        </div>
      </div>
      {enough ? (
        <ResponsiveContainer width="100%" height={240}>
          <LineChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 4 }}>
            <CartesianGrid stroke="#eef2f1" vertical={false} />
            <XAxis dataKey="date" tickFormatter={shortDate} tick={{ fontSize: 11, fill: '#94a3b8' }} />
            <YAxis width={44} tick={{ fontSize: 11, fill: '#94a3b8' }} allowDecimals={false} />
            <Tooltip
              formatter={(v) => [Number(v).toLocaleString(), 'Sleep sessions']}
              labelFormatter={(l) => `Date: ${String(l).split('-').reverse().join('/')}`}
            />
            <Line type="monotone" dataKey="sessions" name="Sleep sessions" stroke="#f26b45" strokeWidth={2.5} dot={false} isAnimationActive={false} />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <div className="au-chart-empty" data-testid="ss-trend-empty">
          {single
            ? `${Number(data[0].sessions || 0).toLocaleString()} sleep session(s) on ${shortDate(data[0].date)}.`
            : 'Not enough data to plot a trend (need at least 2 days).'}
        </div>
      )}
    </div>
  );
};

export default SleepSummaryTrendChart;
